<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-header">
        <div class="header-content">
          <div class="logo-container">
            <img src="/favicon.png" alt="logo" class="header-logo" />
          </div>
          <div class="title-container">
            <h1>鄞州区基础党务小助手</h1>
            <!-- <p class="subtitle">AI智能对话系统</p> -->
          </div>
        </div>
      </div>

      <form @submit.prevent="handleLogin" class="login-form-content">
        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-user"></i>
          </div>
          <input type="text" v-model="loginForm.loginAccount" placeholder="请输入登录账户" required class="form-input" />
        </div>

        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-lock"></i>
          </div>
          <input :type="showPassword ? 'text' : 'password'" v-model="loginForm.password" placeholder="请输入密码" required
            class="form-input" />
          <div class="password-toggle" @click="togglePassword">
            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </div>
        </div>

        <!-- 记住账户和密码选项 -->
        <div class="form-group remember-group">
          <div class="remember-options">
            <label class="remember-checkbox">
              <input type="checkbox" v-model="rememberUsername" @change="handleRememberUsernameChange" />
              <span class="checkmark"></span>
              记住账户
            </label>
            <label class="remember-checkbox">
              <input type="checkbox" v-model="rememberPassword" @change="handleRememberPasswordChange" />
              <span class="checkmark"></span>
              记住密码
            </label>
          </div>
        </div>

        <!-- 移除验证码输入框 -->

        <button type="submit" class="login-button" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </button>

        <div class="register-link">
          还没有账户？<a href="#" @click.prevent="goToRegister">立即注册</a>
        </div>
      </form>

      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>

function isMobileDevice() {
  return (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) || window.innerWidth <= 768; // 同时也可以根据屏幕宽度判断
}

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        loginAccount: '',
        password: ''
      },
      showPassword: false,
      loading: false,
      errorMessage: '',
      rememberUsername: false,
      rememberPassword: false
    }
  },
  mounted() {
    // 页面加载时检查是否有保存的账户信息
    this.loadSavedCredentials();
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.errorMessage = '';

      try {
        // 检测设备类型
        const deviceType = this.detectDeviceType();
        console.log('检测到设备类型:', deviceType);
        
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Device-Type': deviceType // 添加设备类型头
          },
          body: JSON.stringify(this.loginForm)
        });

        const data = await response.json();

        if (data.success) {
          console.log('登录成功，响应数据:', data);
          
          // 保存登录信息到localStorage
          localStorage.setItem('token', data.token);
          localStorage.setItem('sessionId', data.sessionId);
          localStorage.setItem('loginAccount', data.loginAccount);
          localStorage.setItem('displayName', data.displayName);
          localStorage.setItem('userId', data.userId); // 保存用户ID
          localStorage.setItem('userRole', data.userRole); // 保存用户角色
          
          console.log('登录信息已保存到localStorage');
          console.log('当前路由路径:', this.$route.path);

          // 分别处理记住账户和记住密码
          if (this.rememberUsername) {
            localStorage.setItem('rememberedLoginAccount', this.loginForm.loginAccount);
          } else {
            localStorage.removeItem('rememberedLoginAccount');
          }

          if (this.rememberPassword) {
            localStorage.setItem('rememberedPassword', this.loginForm.password);
          } else {
            localStorage.removeItem('rememberedPassword');
          }

          // 获取到sessionId后，更新会话名称
          // 只有当sessionId是新创建的时候才调用外部API更新会话名称
          if (data.sessionId && data.sessionNewlyCreated) {
            try {
              await this.updateSessionName(data.sessionId, data.displayName+'UserId:'+data.userId);
            } catch (error) {
              console.error('更新会话名称失败:', error);
              // 不影响登录流程，只记录错误
            }
          }

          // 跳转到聊天页面，避免重复导航
          console.log('准备跳转，当前路由:', this.$route.path);
          if(isMobileDevice()) {
            console.log('检测到移动设备，跳转到/mobileChat');
            if (this.$route.path !== '/mobileChat') {
              this.$router.push('/mobileChat');
            }
          } else {
            console.log('检测到PC设备，跳转到/chat');
            if (this.$route.path !== '/chat') {
              this.$router.push('/chat');
            }
            // this.$router.push('/mobileChat');
          }
          console.log('跳转完成');
        } else {
          console.log('登录失败:', data.message);
          this.errorMessage = data.message || '登录失败';
        }
      } catch (error) {
        this.errorMessage = '网络错误，请检查连接';
        console.error('Login error:', error);
      } finally {
        this.loading = false;
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    // 加载保存的账户信息
    loadSavedCredentials() {
      const savedLoginAccount = localStorage.getItem('rememberedLoginAccount');
      const savedPassword = localStorage.getItem('rememberedPassword');

      if (savedLoginAccount) {
        this.loginForm.loginAccount = savedLoginAccount;
        this.rememberUsername = true;
      }

      if (savedPassword) {
        this.loginForm.password = savedPassword;
        this.rememberPassword = true;
      }
    },

    // 处理记住账户变化
    handleRememberUsernameChange() {
      if (!this.rememberUsername) {
        // 如果取消勾选，清除保存的登录账户
        localStorage.removeItem('rememberedLoginAccount');
      }
    },

    // 处理记住密码变化
    handleRememberPasswordChange() {
      if (!this.rememberPassword) {
        // 如果取消勾选，清除保存的密码
        localStorage.removeItem('rememberedPassword');
      }
    },

    goToRegister() {
      // 检查当前路由，避免重复导航
      if (this.$route.path !== '/register') {
        this.$router.push('/register');
      }
    },

    /**
     * 更新会话名称
     * @param {string} sessionId 会话ID
     * @param {string} displayName 用户显示名称
     */
    async updateSessionName(sessionId, displayName) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/update-session-name`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `sessionId=${encodeURIComponent(sessionId)}&displayName=${encodeURIComponent(displayName)}`
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.code === 200) {
          console.log('会话名称更新成功:', result.message);
        } else {
          console.warn('会话名称更新失败:', result.message);
        }
        return result;
      } catch (error) {
        console.error('更新会话名称时发生错误:', error);
        throw error;
      }
    },

    // 检测设备类型
    detectDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes('mobile') || userAgent.includes('android') || 
          userAgent.includes('iphone') || userAgent.includes('ipad')) {
        return 'MOBILE';
      }
      return 'PC';
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b6b, #ff8e53);
  background-size: cover;
  background-position: center;
  position: relative;
  background-image: url('@/assets/imgs/bg.jpg');
  background-repeat: no-repeat;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(222, 134, 90);
  opacity: 0.4;
  backdrop-filter: blur(100px);
}

.login-form {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  width: 400px;
  max-width: 90vw;
  position: relative;
  z-index: 1;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.title-container {
  text-align: left;
}

.login-header h1 {
  color: #20252b;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

.subtitle {
  color: #7f8c8d;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
}

.form-group {
  position: relative;
  margin-bottom: 20px;
}

.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
  z-index: 2;
}

.form-input {
  width: 100%;
  padding: 15px 15px 15px 45px;
  border: 2px solid #ecf0f1;
  border-radius: 10px;
  font-size: 16px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #c03333;
  box-shadow: 0 0 0 3px rgba(255, 71, 87, 0.1);
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
  cursor: pointer;
  z-index: 2;
}

.remember-group {
  margin-bottom: 25px;
}

.remember-options {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
}

.remember-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #7f8c8d;
  user-select: none;
}

.remember-checkbox input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #ecf0f1;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  transition: all 0.3s;
}

.remember-checkbox input[type="checkbox"]:checked+.checkmark {
  background: #c03333;
  border-color: #c03333;
}

.remember-checkbox input[type="checkbox"]:checked+.checkmark::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.remember-checkbox:hover .checkmark {
  border-color: #c03333;
}

.login-button {
  width: 100%;
  background: #c03333;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-button:hover:not(:disabled) {
  background: #c03333;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(255, 71, 87, 0.3);
}

.login-button:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.register-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #7f8c8d;
}

.register-link a {
  color: #c03333;
  text-decoration: none;
  font-weight: 600;
}

.register-link a:hover {
  text-decoration: underline;
}

.error-message {
  color: #e74c3c;
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  background: rgba(231, 76, 60, 0.1);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

@media (max-width: 480px) {
  .login-form {
    padding: 30px 20px;
    width: 100%;
    margin: 20px;
  }

  .remember-group {
    margin-bottom: 20px;
  }

  .remember-options {
    gap: 15px;
  }

  .header-content {
    gap: 15px;
  }

  .header-logo {
    width: 28px;
    height: 28px;
  }

  .login-header h1 {
    font-size: 18px;
  }

  .subtitle {
    font-size: 12px;
  }
}
</style>
